module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fields":{"rules":{"add":"Add rule","required":"Required field","nospace":"No space character"}}}}')
  delete Component.options._Ctor
}
